(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorPosition', SectorPosition);

    SectorPosition.$inject = ['$resource'];

    function SectorPosition ($resource) {
        var resourceUrl =  'api/sector-positions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
